
export const OverdueDaysList = [
  {
    label: "days",
    value: "1",
  },
  {
    label: "week",
    value: "7",
  },
  {
    label: "month",
    value: "30",
  },
  {
    label: "quarter",
    value: "182",
  },
  {
    label: "year",
    value: "365",
  },
];

export const chargeStatusOptions = [
  {
    label: "open",
    value: "open",
  },
  {
    label: "closed",
    value: "closed",
  },
  {
    label: "partially paid",
    value: "partially paid",
  },
  {
    label: "reversal",
    value: "reversal",
  },
];

export const paymentStatusOptions = [
  {
    label: "prepaid",
    value: "prepaid",
  },
  {
    label: "refunded",
    value: "refunded",
  },
  {
    label: "reversal",
    value: "reversal",
  },
  {
    label: "partially applied",
    value: "partialy applied",
  },
  {
    label: "close",
    value: "close",
  },
];
